import Element from './Element';
import AnimatableMixin from './mixins/AnimatableMixin';
import HiddenCollapsedMixin from './mixins/HiddenCollapsedMixin';
import mixin from '../privates/utils/mixin';

 /**
 * @class VideoBox
 * @summary Lets you display your videos with creative frames and graphic overlays.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @memberof $w
 * @queryable
 * @tagname videoBox
 * @viewername wysiwyg.viewer.components.MediaPlayer
 * @definitionId wysiwyg.viewer.components.MediaPlayer
 */

class VideoBox extends Element {}

mixin(VideoBox.prototype, HiddenCollapsedMixin.prototype);
mixin(VideoBox.prototype, AnimatableMixin.prototype);

export default VideoBox;
